<template>
  <!-- eslint-disable -->
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    :class="className"
    v-if="name === 'campaign'"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.9617 1.46872C21.0956 0.54341 18.9044 0.543412 17.0383 1.46872L5.37167 7.25384C3.10226 8.37917 1.66667 10.6934 1.66667 13.2265V26.7737C1.66667 29.3068 3.10226 31.6211 5.37167 32.7464L17.0383 38.5315C18.9044 39.4568 21.0956 39.4568 22.9617 38.5315L34.6283 32.7464C36.8977 31.6211 38.3333 29.3068 38.3333 26.7737V13.2265C38.3333 10.6934 36.8977 8.37917 34.6283 7.25384L22.9617 1.46872ZM15 18.3335C16.841 18.3335 18.3333 16.8411 18.3333 15.0001C18.3333 13.1592 16.841 11.6668 15 11.6668C13.1591 11.6668 11.6667 13.1592 11.6667 15.0001C11.6667 16.8411 13.1591 18.3335 15 18.3335ZM28.3333 25.0001C28.3333 26.8411 26.8409 28.3335 25 28.3335C23.159 28.3335 21.6667 26.8411 21.6667 25.0001C21.6667 23.1592 23.159 21.6668 25 21.6668C26.8409 21.6668 28.3333 23.1592 28.3333 25.0001ZM27.8452 14.512C28.4961 13.8611 28.4961 12.8058 27.8452 12.1549C27.1943 11.5041 26.139 11.5041 25.4882 12.1549L12.1548 25.4883C11.5039 26.1392 11.5039 27.1944 12.1548 27.8453C12.8057 28.4962 13.861 28.4962 14.5118 27.8453L27.8452 14.512Z"
      fill="#F27A1A"
    />
  </svg>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    :class="className"
    v-else-if="name === 'offer'"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 20C0.89543 20 0 20.8954 0 22V35.5C0 36.6046 0.895432 37.5 2 37.5H2.13044C3.235 37.5 4.13043 36.6046 4.13043 35.5V22C4.13043 20.8954 3.235 20 2.13043 20H2ZM10.3644 20.0155C10.4224 20.0052 10.4812 19.9999 10.5401 20.0004C11.2496 20.0069 11.9564 20.0913 12.6485 20.2523L27.9499 23.8113C28.9957 24.0545 29.7378 25.006 29.7378 26.1036C29.7378 27.4019 28.7094 28.4543 27.4408 28.4543H19.1003C18.5879 28.4543 18.1726 28.8794 18.1726 29.4038C18.1726 29.8395 18.4623 30.2193 18.8753 30.325L24.7812 31.836L35.3614 29.8058C36.7318 29.5428 37.9986 30.6188 37.9986 32.0458C37.9986 32.9465 37.4804 33.7626 36.6762 34.1284L25.049 39.4171C23.7999 39.9852 22.4093 40.143 21.0689 39.8687L6.57625 36.8332C6.11303 36.7362 5.78125 36.3277 5.78125 35.8544V21.6707C5.78125 21.1862 6.1286 20.7714 6.60559 20.6862L10.3644 20.0155Z"
      fill="#FF5043"
    />
    <mask
      id="mask0_1961_41047"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="3"
      y="0"
      width="37"
      height="28"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3 19.1355C5.07317 17.6321 8.39024 16.402 9.63415 16.812L29.4639 21.8547C31.6464 22.3289 33.1951 24.1836 33.1951 26.323C33.1951 26.9149 33.0777 27.4806 32.8639 28L35.8941 27.4569C38.8008 26.9359 39 26.323 39 23.5525C39 25.3367 40 11.4809 40 8.20065L36.8941 0C34.1951 0 22.5854 0 19.2683 0L10.561 6.56054L3 19.1355Z"
        fill="#F27A1A"
      />
    </mask>
    <g mask="url(#mask0_1961_41047)">
      <path
        d="M24.735 0.745448C25.4701 0.147424 26.5241 0.147424 27.2592 0.745449L28.4193 1.68917C28.8614 2.04883 29.436 2.20278 29.9987 2.11237L31.4752 1.87513C32.4109 1.72479 33.3236 2.25176 33.6613 3.13723L34.1941 4.53457C34.3971 5.0671 34.8177 5.4877 35.3503 5.69076L36.7476 6.22357C37.6331 6.56121 38.16 7.47394 38.0097 8.4096L37.7725 9.88614C37.6821 10.4489 37.836 11.0234 38.1957 11.4655L39.1394 12.6256C39.7374 13.3608 39.7374 14.4147 39.1394 15.1498L38.1957 16.3099C37.836 16.752 37.6821 17.3266 37.7725 17.8893L38.0097 19.3659C38.16 20.3015 37.6331 21.2142 36.7476 21.5519L35.3503 22.0847C34.8177 22.2878 34.3971 22.7084 34.1941 23.2409L33.6613 24.6382C33.3236 25.5237 32.4109 26.0507 31.4752 25.9003L29.9987 25.6631C29.436 25.5727 28.8614 25.7266 28.4193 26.0863L27.2592 27.03C26.5241 27.628 25.4701 27.628 24.735 27.03L23.5749 26.0863C23.1328 25.7266 22.5582 25.5727 21.9955 25.6631L20.519 25.9003C19.5833 26.0507 18.6706 25.5237 18.3329 24.6382L17.8001 23.2409C17.5971 22.7084 17.1765 22.2878 16.6439 22.0847L15.2466 21.5519C14.3611 21.2142 13.8342 20.3015 13.9845 19.3659L14.2217 17.8893C14.3122 17.3266 14.1582 16.752 13.7985 16.3099L12.8548 15.1498C12.2568 14.4147 12.2568 13.3608 12.8548 12.6256L13.7985 11.4655C14.1582 11.0234 14.3122 10.4489 14.2217 9.88614L13.9845 8.4096C13.8342 7.47394 14.3611 6.56121 15.2466 6.22357L16.6439 5.69076C17.1765 5.4877 17.5971 5.0671 17.8001 4.53457L18.3329 3.13723C18.6706 2.25176 19.5833 1.72479 20.519 1.87513L21.9955 2.11237C22.5582 2.20278 23.1328 2.04883 23.5749 1.68917L24.735 0.745448Z"
        fill="#FF3028"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.3339 10.012C24.3339 10.9334 23.5876 11.6803 22.6669 11.6803C21.7463 11.6803 21 10.9334 21 10.012C21 9.09067 21.7463 8.34375 22.6669 8.34375C23.5876 8.34375 24.3339 9.09067 24.3339 10.012ZM30.9979 16.6839C30.9979 17.6053 30.2516 18.3522 29.331 18.3522C28.4104 18.3522 27.6641 17.6053 27.6641 16.6839C27.6641 15.7626 28.4104 15.0156 29.331 15.0156C30.2516 15.0156 30.9979 15.7626 30.9979 16.6839ZM30.1694 9.17794C29.7091 8.71725 28.9628 8.71726 28.5025 9.17795L21.8347 15.8512C21.3744 16.3119 21.3744 17.0588 21.8347 17.5195C22.295 17.9802 23.0413 17.9802 23.5016 17.5195L30.1694 10.8463C30.6298 10.3856 30.6297 9.63863 30.1694 9.17794Z"
        fill="white"
      />
    </g>
  </svg>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    :class="className"
    v-else-if="name === 'discount'"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.9999 4.16667C21.9822 4.16667 23.7336 5.15545 24.7877 6.66671H15.2121C16.2662 5.15545 18.0176 4.16667 19.9999 4.16667ZM6.55279 6.66671H10.5689C11.9417 2.78271 15.6458 0 19.9999 0C24.354 0 28.0581 2.78271 29.4309 6.66671H33.447C36.1026 6.66671 38.295 8.74271 38.4396 11.3944L39.7123 34.7277C39.8685 37.5919 37.5882 40 34.7197 40H5.28006C2.41162 40 0.131254 37.5919 0.287482 34.7277L1.56021 11.3944C1.70485 8.74271 3.89717 6.66671 6.55279 6.66671ZM14.4445 20.5556C15.9786 20.5556 17.2223 19.3119 17.2223 17.7778C17.2223 16.2437 15.9786 15 14.4445 15C12.9104 15 11.6667 16.2437 11.6667 17.7778C11.6667 19.3119 12.9104 20.5556 14.4445 20.5556ZM25.5555 31.6666C27.0896 31.6666 28.3332 30.4229 28.3332 28.8888C28.3332 27.3547 27.0896 26.111 25.5555 26.111C24.0213 26.111 22.7777 27.3547 22.7777 28.8888C22.7777 30.4229 24.0213 31.6666 25.5555 31.6666ZM24.1672 16.389C24.9343 15.6219 26.178 15.6219 26.945 16.3889C27.7121 17.156 27.7121 18.3997 26.945 19.1668L15.8338 30.2779C15.0668 31.0449 13.8231 31.0449 13.0561 30.2779C12.289 29.5108 12.289 28.2671 13.0561 27.5001L24.1672 16.389Z"
      fill="#8C4EFF"
    />
  </svg>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    :class="className"
    v-else-if="name === 'coupon'"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.33333 5H25V6.66667C25 7.58714 25.7462 8.33333 26.6667 8.33333C27.5871 8.33333 28.3333 7.58714 28.3333 6.66667V5H36.6667C38.5076 5 40 6.49238 40 8.33333V16.6667C38.159 16.6667 36.6667 18.1591 36.6667 20C36.6667 21.8409 38.159 23.3333 40 23.3333V31.6667C40 33.5076 38.5076 35 36.6667 35H28.3333V33.3333C28.3333 32.4129 27.5871 31.6667 26.6667 31.6667C25.7462 31.6667 25 32.4129 25 33.3333V35H3.33333C1.49238 35 0 33.5076 0 31.6667V23.3333C1.84095 23.3333 3.33333 21.8409 3.33333 20C3.33333 18.1591 1.84095 16.6667 0 16.6667V8.33333C0 6.49238 1.49238 5 3.33333 5ZM28.3333 13.3333C28.3333 12.4129 27.5871 11.6667 26.6667 11.6667C25.7462 11.6667 25 12.4129 25 13.3333V16.6667C25 17.5871 25.7462 18.3333 26.6667 18.3333C27.5871 18.3333 28.3333 17.5871 28.3333 16.6667V13.3333ZM26.6667 21.6667C27.5871 21.6667 28.3333 22.4129 28.3333 23.3333V26.6667C28.3333 27.5871 27.5871 28.3333 26.6667 28.3333C25.7462 28.3333 25 27.5871 25 26.6667V23.3333C25 22.4129 25.7462 21.6667 26.6667 21.6667Z"
      fill="#0BC15C"
    />
  </svg>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    :class="className"
    v-else-if="name === 'ads'"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.9605 0.169812C13.3677 0.519385 13.1646 1.29361 13.5068 1.89909L14.0646 2.88577L4.52377 12.3081C3.8696 12.9542 3.72986 13.9721 4.18484 14.777L9.112 23.4935C9.34436 23.9046 9.82508 24.0957 10.2684 23.9532L14.6283 22.5516C14.9998 22.4321 15.2684 22.1016 15.315 21.7067L15.8243 17.3887L21.1757 15.466L21.687 16.3705C22.0293 16.9759 22.7873 17.1834 23.3801 16.8338C23.9729 16.4843 24.176 15.71 23.8337 15.1045L15.6536 0.63317C15.3113 0.0276909 14.5533 -0.179761 13.9605 0.169812ZM13.7385 18.1381L9.28011 19.74L10.4317 21.7772L13.4227 20.8157L13.7385 18.1381Z"
      fill="#F27A1A"
    />
    <path
      d="M0.619916 15.0531C0.0271115 15.4027 -0.175998 16.1769 0.166258 16.7824L2.89298 21.6062C3.23523 22.2116 3.99325 22.4191 4.58606 22.0695C5.17886 21.72 5.38197 20.9457 5.03971 20.3403L2.31299 15.5165C1.97074 14.911 1.21272 14.7035 0.619916 15.0531Z"
      fill="#F27A1A"
    />
  </svg>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    :class="className"
    v-else-if="name === 'pricing'"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.0655 11.484L23.3143 12.198C23.6301 12.3801 23.8599 12.6775 23.9537 13.0255C24.0475 13.3735 23.9977 13.7438 23.8151 14.0559L22.4451 16.4102C22.356 16.5644 22.2368 16.6997 22.0942 16.8083C21.9517 16.9169 21.7887 16.9966 21.6146 17.0429C21.4405 17.0891 21.2588 17.101 21.0801 17.0777C20.9013 17.0545 20.729 16.9967 20.5731 16.9075L19.3088 16.1827C18.6222 16.762 17.8509 17.2456 16.9999 17.5811V16.5C16.9999 14.9688 16.6377 13.5222 15.9942 12.2413C16.6113 11.6918 17 10.8913 17 10C17 8.34315 15.6568 7 14 7C13.1087 7 12.3082 7.38867 11.7587 8.00577C10.4778 7.36227 9.03116 7 7.49995 7C6.39886 7 5.34152 7.18733 4.35807 7.53185C4.22755 7.37931 4.13132 7.19906 4.07837 7.00273C3.98462 6.65509 4.03412 6.28511 4.21611 5.97315L5.58527 3.61795C5.67425 3.46374 5.79343 3.3284 5.93593 3.21978C6.07843 3.11115 6.24142 3.03139 6.41546 2.98511C6.58951 2.93882 6.77115 2.92694 6.9499 2.95013C7.12864 2.97333 7.30093 3.03116 7.45681 3.12026L8.6757 3.81727C9.43316 3.17865 10.2942 2.65599 11.2511 2.31976V1.3594C11.2503 1.18162 11.2852 1.00544 11.3537 0.840908C11.4221 0.676378 11.5229 0.526725 11.6502 0.400492C11.7775 0.27426 11.9288 0.173921 12.0955 0.105205C12.2622 0.0364889 12.4411 0.000740667 12.6219 0H15.3622C15.7272 0.00149404 16.0767 0.1455 16.3338 0.40035C16.5908 0.6552 16.7344 1.00003 16.733 1.359V2.31936C17.6899 2.65558 18.5505 3.17824 19.308 3.81687L20.5453 3.10939C20.7012 3.02017 20.8735 2.96225 21.0523 2.93899C21.2311 2.91573 21.4128 2.92758 21.5869 2.97387C21.761 3.02016 21.9241 3.09997 22.0666 3.20866C22.2091 3.31735 22.3283 3.45277 22.4172 3.60708L23.7872 5.96066C23.9693 6.27265 24.0188 6.6427 23.9249 6.99038C23.8311 7.33805 23.6015 7.63525 23.2861 7.81735L22.0655 8.51598C22.2642 9.49568 22.2642 10.5043 22.0655 11.484Z"
      fill="#F27A1A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.0001 16.5C15.0001 20.6421 11.6422 24 7.50005 24C3.35789 24 0 20.6421 0 16.5C0 12.3578 3.35789 8.99991 7.50005 8.99991C11.6422 8.99991 15.0001 12.3578 15.0001 16.5ZM6.51154 20.25C6.34579 20.25 6.16426 20.2396 5.96694 20.2189C5.76962 20.2051 5.59204 20.1809 5.43418 20.1464V16.9765L4.28579 17.3184V16.4171L5.43418 16.0753V15.433L4.28579 15.7748V14.8736L5.43418 14.5317V12.75H7.16269V14.0138L9.00958 13.4544V14.3556L7.16269 14.915V15.5573L9.00958 14.9979V15.8888L7.16269 16.4482V18.9862C7.65993 18.9102 8.04667 18.7652 8.32292 18.5511C8.60705 18.337 8.80437 18.0573 8.91487 17.712C9.03326 17.3667 9.09245 16.9696 9.09245 16.5207H10.7144C10.7144 16.9972 10.6434 17.4599 10.5013 17.9088C10.3592 18.3508 10.1264 18.7479 9.8028 19.1001C9.48709 19.4523 9.05694 19.732 8.51234 19.9392C7.97564 20.1464 7.3087 20.25 6.51154 20.25Z"
      fill="#F27A1A"
    />
  </svg>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    :class="className"
    v-else-if="name === 'store'"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 12C20.4777 12.4275 21.0931 12.7042 21.7715 12.7552L21.9999 12.7638L22 21C22 22.1046 21.1046 23 20 23H4C2.89543 23 2 22.1046 2 21L1.9999 12.7638C2.76868 12.7638 3.46992 12.4746 4 12C4.28856 12.2582 4.6274 12.4615 5.00003 12.5931L5 18H19L19.0013 12.5927C19.3736 12.4609 19.7121 12.2578 20 12ZM19.5 1C20.4443 1 21.3334 1.44458 21.9 2.2L23.4 4.2C23.7895 4.71929 24 5.35089 24 6V9C24 10.1046 23.1046 11 22 11C20.8954 11 20 10.1046 20 9C20 10.1046 19.1046 11 18 11C16.8954 11 16 10.1046 16 9C16 10.1046 15.1046 11 14 11C12.8954 11 12 10.1046 12 9C12 10.1046 11.1046 11 10 11C8.89543 11 8 10.1046 8 9C8 10.1046 7.10457 11 6 11C4.89543 11 4 10.1046 4 9C4 10.1046 3.10457 11 2 11C0.895431 11 0 10.1046 0 9V6C0 5.35089 0.210534 4.71929 0.6 4.2L2.1 2.2C2.66656 1.44458 3.55573 1 4.5 1H19.5Z"
      fill="#F27A1A"
    />
  </svg>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    :class="className"
    v-else-if="name === 'truck'"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 3C0.447715 3 0 3.44772 0 4L0 18C0 18.5523 0.447715 19 1 19H3.03544C3.01209 18.8367 3 18.6698 3 18.5C3 16.567 4.567 15 6.5 15C8.433 15 10 16.567 10 18.5C10 18.6698 9.98791 18.8367 9.96456 19H13L13 7C13 5.89543 13.8954 5 15 5H17V4C17 3.44772 16.5523 3 16 3L1 3Z"
      fill="#F27A1A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14 7C14 6.44772 14.4477 6 15 6L20.382 6C20.7607 6 21.107 6.214 21.2764 6.55279L23.6833 11.3666C23.8916 11.7831 24 12.2425 24 12.7082L24 18C24 18.5523 23.5523 19 23 19H21.9646C21.9879 18.8367 22 18.6698 22 18.5C22 16.567 20.433 15 18.5 15C16.567 15 15 16.567 15 18.5C15 18.6698 15.0121 18.8367 15.0354 19H14L14 7ZM21.6875 11.7969L20.2639 8.59386C20.1034 8.23273 19.7453 8 19.3501 8L16 8V12.5H21.2306C21.5924 12.5 21.8345 12.1276 21.6875 11.7969Z"
      fill="#F27A1A"
    />
    <path
      d="M21 18.5C21 19.8807 19.8807 21 18.5 21C17.1193 21 16 19.8807 16 18.5C16 17.1193 17.1193 16 18.5 16C19.8807 16 21 17.1193 21 18.5Z"
      fill="#F27A1A"
    />
    <path
      d="M9 18.5C9 19.8807 7.88071 21 6.5 21C5.11929 21 4 19.8807 4 18.5C4 17.1193 5.11929 16 6.5 16C7.88071 16 9 17.1193 9 18.5Z"
      fill="#F27A1A"
    />
  </svg>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    :class="className"
    v-else-if="name === 'monitor'"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3 1C1.34315 1 0 2.34315 0 4V16C0 17.6569 1.34315 19 3 19H9V21H6C5.44772 21 5 21.4477 5 22C5 22.5523 5.44772 23 6 23H18C18.5523 23 19 22.5523 19 22C19 21.4477 18.5523 21 18 21H15V19H21C22.6569 19 24 17.6569 24 16V4C24 2.34315 22.6569 1 21 1H3ZM18 5C17.4477 5 17 5.44772 17 6V14C17 14.5523 17.4477 15 18 15C18.5523 15 19 14.5523 19 14V6C19 5.44772 18.5523 5 18 5ZM11 9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V9ZM6 10C5.44772 10 5 10.4477 5 11V14C5 14.5523 5.44772 15 6 15C6.55228 15 7 14.5523 7 14V11C7 10.4477 6.55228 10 6 10Z"
      fill="#F27A1A"
    />
  </svg>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    :class="className"
    v-else-if="name === 'hearth'"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2095 1C16.3118 1 15.424 1.1844 14.5972 1.5415C13.7704 1.89854 13.022 2.42067 12.3936 3.07599C12.387 3.08288 12.3805 3.08987 12.374 3.09696L12 3.5L11.6252 3.09677C11.6188 3.08969 11.6123 3.08271 11.6057 3.07582C10.3358 1.75224 8.60445 1.0006 6.78997 1.0006C4.9755 1.0006 3.24413 1.75224 1.97426 3.07582C0.705738 4.39798 0 6.18272 0 8.03541C0 9.8881 0.705738 11.6728 1.97426 12.995L11.2781 22.6923C11.4667 22.8889 11.7273 23 11.9997 23C12.2721 23 12.5327 22.8889 12.7213 22.6923L22.0252 12.995C22.6538 12.3401 23.1503 11.5648 23.4884 10.7144C23.8265 9.86391 24 8.95371 24 8.03541C24 7.1171 23.8265 6.20691 23.4884 5.35646C23.1503 4.50596 22.6537 3.73057 22.025 3.07565C21.3967 2.4205 20.6484 1.89849 19.8218 1.5415C18.9949 1.1844 18.1071 1 17.2095 1Z"
      fill="#F27A1A"
    />
  </svg>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    :class="className"
    v-else-if="name === 'growth'"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.7565 4.12228C15.5632 4.31551 15.4547 4.57757 15.4547 4.85083V7.08823L10.6049 11.938C10.2025 12.3404 10.2025 12.9927 10.6049 13.3951C11.0073 13.7975 11.6596 13.7975 12.062 13.3951L16.9118 8.54531H19.1492C19.4224 8.54531 19.6845 8.43676 19.8777 8.24354L23.8481 4.27317C24.1726 3.94864 23.9428 3.39374 23.4838 3.39374H20.6063V0.51619C20.6063 0.0572343 20.0514 -0.172612 19.7268 0.151918L15.7565 4.12228Z"
      fill="#F27A1A"
    />
    <path
      d="M13.394 6.29252V6.48469L11.3334 8.54531C9.0573 8.54534 7.21219 10.3905 7.21219 12.6666C7.21219 14.9427 9.05734 16.7878 11.3334 16.7878C13.6095 16.7878 15.4547 14.9427 15.4547 12.6666L17.5151 10.606H17.7075C17.9172 11.2551 18.0305 11.9476 18.0305 12.6666C18.0305 16.3652 15.0321 19.3636 11.3334 19.3636C7.63477 19.3636 4.63641 16.3652 4.63641 12.6666C4.63641 8.96789 7.63477 5.96953 11.3334 5.96953C12.0524 5.96953 12.7449 6.08282 13.394 6.29252Z"
      fill="#F27A1A"
    />
    <path
      d="M13.4697 4.17129C12.7859 3.99991 12.0703 3.9089 11.3334 3.9089C6.49672 3.9089 2.57578 7.82984 2.57578 12.6666C2.57578 17.5033 6.49672 21.4242 11.3334 21.4242C16.1702 21.4242 20.0911 17.5033 20.0911 12.6666C20.0911 11.9297 20.0001 11.2141 19.8287 10.5304C20.3946 10.4028 20.9181 10.1174 21.3348 9.7007L22.0542 8.98123C22.4513 10.1366 22.6669 11.3764 22.6669 12.6666C22.6669 18.9258 17.5927 24 11.3334 24C5.07415 24 0 18.9258 0 12.6666C0 6.40727 5.07415 1.33312 11.3334 1.33312C12.6236 1.33312 13.8634 1.5487 15.0188 1.9458L14.2993 2.66528C13.8826 3.08197 13.5972 3.60539 13.4697 4.17129Z"
      fill="#F27A1A"
    />
  </svg>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    :class="className"
    v-else-if="name === 'market'"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.7495 6.10358C16.7495 6.2237 16.7277 6.24105 16.7091 6.25585C16.707 6.25748 16.705 6.25909 16.7031 6.26079C16.6294 6.3255 16.4287 6.44278 15.9755 6.54171C15.0524 6.74325 13.7117 6.75 11.9995 6.75C10.2873 6.75 8.94659 6.74325 8.02349 6.54171C7.57036 6.44278 7.3696 6.3255 7.29594 6.26079C7.294 6.25909 7.29198 6.25748 7.28993 6.25585C7.27132 6.24105 7.24951 6.2237 7.24951 6.10358C7.24951 3.40277 9.39624 1.25 11.9995 1.25C14.6028 1.25 16.7495 3.40277 16.7495 6.10358Z"
      stroke="#F27A1A"
      stroke-width="2.5"
    />
    <mask
      id="path-2-inside-1_1965_41309"
      fill="white"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.02245 7.8109C1.12226 6.23062 2.43306 5 4.01649 5H19.9835C21.5669 5 22.8777 6.23062 22.9775 7.8109L23.4 14.5L23.7986 20.8109C23.9077 22.5387 22.5358 24 20.8045 24H3.19544C1.46419 24 0.0922759 22.5387 0.2014 20.8109L1.02245 7.8109ZM5.49965 9.25C5.49965 8.55964 6.0593 8 6.74965 8C7.44001 8 7.99965 8.55964 7.99965 9.25C7.99965 9.94036 7.44001 10.5 6.74965 10.5C6.0593 10.5 5.49965 9.94036 5.49965 9.25ZM17.2496 8C16.5592 8 15.9996 8.55964 15.9996 9.25C15.9996 9.94036 16.5592 10.5 17.2496 10.5C17.94 10.5 18.4996 9.94036 18.4996 9.25C18.4996 8.55964 17.94 8 17.2496 8Z"
      />
    </mask>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.02245 7.8109C1.12226 6.23062 2.43306 5 4.01649 5H19.9835C21.5669 5 22.8777 6.23062 22.9775 7.8109L23.4 14.5L23.7986 20.8109C23.9077 22.5387 22.5358 24 20.8045 24H3.19544C1.46419 24 0.0922759 22.5387 0.2014 20.8109L1.02245 7.8109ZM5.49965 9.25C5.49965 8.55964 6.0593 8 6.74965 8C7.44001 8 7.99965 8.55964 7.99965 9.25C7.99965 9.94036 7.44001 10.5 6.74965 10.5C6.0593 10.5 5.49965 9.94036 5.49965 9.25ZM17.2496 8C16.5592 8 15.9996 8.55964 15.9996 9.25C15.9996 9.94036 16.5592 10.5 17.2496 10.5C17.94 10.5 18.4996 9.94036 18.4996 9.25C18.4996 8.55964 17.94 8 17.2496 8Z"
      fill="#F27A1A"
    />
    <path
      d="M1.02245 7.8109L0.0244411 7.74787L1.02245 7.8109ZM22.9775 7.8109L23.9755 7.74787V7.74787L22.9775 7.8109ZM23.4 14.5L22.402 14.563L23.4 14.5ZM23.7986 20.8109L22.8006 20.8739V20.8739L23.7986 20.8109ZM0.2014 20.8109L1.19941 20.8739L0.2014 20.8109ZM4.01649 4C1.90524 4 0.157518 5.64083 0.0244411 7.74787L2.02046 7.87394C2.087 6.82041 2.96087 6 4.01649 6V4ZM19.9835 4H4.01649V6H19.9835V4ZM23.9755 7.74787C23.8425 5.64083 22.0947 4 19.9835 4V6C21.0391 6 21.913 6.82041 21.9795 7.87394L23.9755 7.74787ZM24.398 14.437L23.9755 7.74787L21.9795 7.87393L22.402 14.563L24.398 14.437ZM24.7966 20.7479L24.398 14.437L22.402 14.563L22.8006 20.8739L24.7966 20.7479ZM20.8045 25C23.1129 25 24.9421 23.0516 24.7966 20.7479L22.8006 20.8739C22.8733 22.0258 21.9587 23 20.8045 23V25ZM3.19544 25H20.8045V23H3.19544V25ZM-0.796611 20.7479C-0.94211 23.0516 0.887113 25 3.19544 25V23C2.04127 23 1.12666 22.0258 1.19941 20.8739L-0.796611 20.7479ZM0.0244411 7.74787L-0.796611 20.7479L1.19941 20.8739L2.02046 7.87394L0.0244411 7.74787ZM6.74965 7C5.50701 7 4.49965 8.00736 4.49965 9.25H6.49965C6.49965 9.11193 6.61158 9 6.74965 9V7ZM8.99965 9.25C8.99965 8.00736 7.9923 7 6.74965 7V9C6.88773 9 6.99965 9.11193 6.99965 9.25H8.99965ZM6.74965 11.5C7.9923 11.5 8.99965 10.4926 8.99965 9.25H6.99965C6.99965 9.38807 6.88773 9.5 6.74965 9.5V11.5ZM4.49965 9.25C4.49965 10.4926 5.50701 11.5 6.74965 11.5V9.5C6.61158 9.5 6.49965 9.38807 6.49965 9.25H4.49965ZM16.9996 9.25C16.9996 9.11193 17.1115 9 17.2496 9V7C16.007 7 14.9996 8.00736 14.9996 9.25H16.9996ZM17.2496 9.5C17.1115 9.5 16.9996 9.38807 16.9996 9.25H14.9996C14.9996 10.4926 16.007 11.5 17.2496 11.5V9.5ZM17.4996 9.25C17.4996 9.38807 17.3877 9.5 17.2496 9.5V11.5C18.4922 11.5 19.4996 10.4926 19.4996 9.25H17.4996ZM17.2496 9C17.3877 9 17.4996 9.11193 17.4996 9.25H19.4996C19.4996 8.00736 18.4922 7 17.2496 7V9Z"
      fill="#F27A1A"
      mask="url(#path-2-inside-1_1965_41309)"
    />
  </svg>
  <svg
    width="6"
    height="10"
    viewBox="0 0 6 10"
    fill="none"
    :class="className"
    v-else-if="name === 'chevron'"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.292894 8.29289C-0.0976307 8.68342 -0.0976307 9.31658 0.292894 9.70711C0.683418 10.0976 1.31658 10.0976 1.70711 9.70711L0.292894 8.29289ZM5 5L5.70711 5.70711C6.09763 5.31658 6.09763 4.68342 5.70711 4.29289L5 5ZM1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683418 -0.0976311 1.31658 0.292893 1.70711L1.70711 0.292893ZM1.70711 9.70711L5.70711 5.70711L4.29289 4.29289L0.292894 8.29289L1.70711 9.70711ZM5.70711 4.29289L1.70711 0.292893L0.292893 1.70711L4.29289 5.70711L5.70711 4.29289Z"
      fill="#273142"
    />
  </svg>
</template>
<script>
export default {
  name: 'Icon',
  props: {
    name: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>

</style>
